export const DateDisplay = ({ pdfURL }) => {
  const today = new Date();

  const gregorianDate = new Intl.DateTimeFormat("en-UK", {
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(today);

  const hijriDate = new Intl.DateTimeFormat("en-UK", {
    calendar: 'islamicc',
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(today);

  return (
    <div className="m-date-wrapper mceNonEditable">
      <a target="_blank" rel="noreferrer noopener" href={pdfURL}>
        Download Timetable
      </a>
      <p>&nbsp;&nbsp;</p>
      <div className="gregorian">{gregorianDate}</div>
      <p>&nbsp;&nbsp;</p>
      <div className="hijri">{hijriDate}</div>
    </div>
  );
};
